import { render, staticRenderFns } from "./RiskScoreRenderer.vue?vue&type=template&id=5b45815b&scoped=true"
import script from "./RiskScoreRenderer.vue?vue&type=script&lang=js"
export * from "./RiskScoreRenderer.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreRenderer.vue?vue&type=style&index=0&id=5b45815b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45815b",
  null
  
)

export default component.exports